import { defineComponent as _defineComponent } from 'vue'
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const showFooter = computed<boolean>(() => route.meta && route.meta.footer);

const __returned__ = { route, showFooter, AppHeader, AppFooter, computed, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})